var map = {
	"./dark.svg": "c777",
	"./facebook.svg": "1825",
	"./instagram.svg": "6e54",
	"./light.svg": "9512",
	"./linkedin.svg": "b044",
	"./socials.svg": "27eb",
	"./telegram-bot.svg": "4bdb",
	"./telegram.svg": "2209",
	"./vk.svg": "17ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c76d";